import { useContext } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { CommonContext } from "../../App";
import { useTranslation } from "react-i18next";
import DateFilter from "../../Components/CommonComponent/Dropdown/DateFilter";

export default function TabButtons() {
  const location = useLocation();
  const { userData, setDateRange } = useContext(CommonContext);
  const { t } = useTranslation();
  // 🔹 Base tabs
  const tabs = [
    { title: t("balanceSheet"), path: "balance-sheet" },
    { title: t("trialBalance"), path: "trial-balance" },
  ];

  // 🔹 Conditionally add admin-only tab
  if (userData && userData?.user?.role === "admin") {
    tabs.splice(1, 0, { title: t("profit&Loss"), path: "profit-loss" });
  }


  return (
    <div>
      <header className="tabs-header bg-theme-webBackground   sticky top-0 z-[990]  py-1 pt-2 flex gap-3 px-2 justify-between ">
        <div className="flex gap-3">
          {tabs.map((tab) => {
            // const isActive =
            //   location.pathname === "/reports" && tab.path === "balance-sheet"
            //     ? true
            //     : location.pathname.endsWith(tab.path);

             let isActive = false;

          if (tab.path === "balance-sheet") {
            isActive =
              location.pathname === "/reports" ||
              location.pathname.startsWith("/reports/balance-sheet");
          }

          if (tab.path === "profit-loss") {
            isActive =
              location.pathname.startsWith("/reports/profit-loss");
          }
          if (tab.path === "trial-balance") {
            isActive =
              location.pathname.startsWith("/reports/trial-balance");
          }

            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`tab no-underline rounded-1 h-7 mt-[3px] pt-[3px] text-sm  px-2 ${isActive
                  ? `bg-theme-headerBg text-theme-color font-medium border-1 border-theme-headerBg`
                  : `text-theme-tabColor border-1  border-black hover:!border-theme-headerBg  hover:!text-theme-headerBg `
                  }`}
              >
                {tab.title}
              </Link>
            );
          })}
        </div>

        {/* <div className="flex gap-2" >
         { (location.pathname=== "/reports" || location.pathname=== "/reports/balance-sheet") && <div className="mt-2 font-medium">As at : </div>} 
          <DateFilter
            customMode={
             (location.pathname=== "/reports" || location.pathname=== "/reports/balance-sheet"
              //  || location.pathname=== "/reports/profit-loss" || location.pathname=== "/reports/profit-loss/statement" || location.pathname=== "/reports/profit-loss/utilisation" 
              )
                ? "single"
                : "range"
            }
            //  availableFilters={[ "default","today", "yesterday","lastWeek" ,"last15", "lastMonth", "thisMonth","custom"]}
            availableFilters={filterMap[location.pathname] || undefined}
            onChange={(r) => setDateRange({
              startDate: r.startDate,
              endDate:
             (location.pathname=== "/reports" || location.pathname=== "/reports/balance-sheet" 
                ? (r.startDate)
                : (r.endDate))
            
            })} />
        </div> */}
      </header>


      <main className="tab-content">
        <Outlet />
      </main>
    </div>
  );
}
